export interface ForthLeafIdentity {
  email: string;
  subject: string;
}

export interface ForthLeafIdentityClaims {
  email?: string;
  sub?: string;
  upn?: string;
}

export const getForthLeafIdentitySubject = (claims: ForthLeafIdentityClaims | undefined) =>
  claims?.sub ?? claims?.upn ?? claims?.email;

export const resolveForthLeafIdentity = async (
  getIdTokenClaims: () => Promise<ForthLeafIdentityClaims | undefined>,
): Promise<ForthLeafIdentity> => {
  const claims = await getIdTokenClaims();
  const email = claims?.upn ?? claims?.email;
  const subject = getForthLeafIdentitySubject(claims);

  if (!email || !subject) {
    throw new Error("Authenticated user identity is unavailable.");
  }

  return { email, subject };
};
